import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceCustomFieldOptionProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-custom-field-option-project-limit',
	path: '/jira/settings/system/performance/metrics/customfieldoption/projectlimit',
};
